__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "observability-dashboard-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@matillion/component-library", "27.4.2", () => (Promise.all([__webpack_require__.e(943), __webpack_require__.e(65), __webpack_require__.e(368), __webpack_require__.e(117), __webpack_require__.e(495), __webpack_require__.e(480)]).then(() => (() => (__webpack_require__(81368))))));
			register("@matillion/hub-client", "14.23.0", () => (Promise.all([__webpack_require__.e(65), __webpack_require__.e(564), __webpack_require__.e(117), __webpack_require__.e(303), __webpack_require__.e(99)]).then(() => (() => (__webpack_require__(27564))))));
			register("@matillion/micro-client", "1.1.0", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(548)]).then(() => (() => (__webpack_require__(13167))))));
			register("@matillion/micro-router", "2.4.1", () => (Promise.all([__webpack_require__.e(1), __webpack_require__.e(117), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(82001))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(117)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "6.21.3", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(117), __webpack_require__.e(495)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};